export default function Features() {
  const features = [
    {
      icon: 'ri-lock-password-line',
      title: 'AES-256 Encryption',
      description: 'Bank-level encryption technology that ensures your data remains completely secure and private from any unauthorized access or cyber threats.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access our worldwide network of high-speed servers strategically located across multiple continents for optimal performance and reliability.'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Zero-Speed Loss',
      description: 'Experience lightning-fast connection speeds with our optimized infrastructure that guarantees no performance degradation while staying protected.'
    }
  ];

  return (
    <section id="features" className="py-32 px-32 bg-[#F7F9FC]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-24">
          <p className="text-[#00D4FF] text-xs font-bold tracking-[2px] uppercase mb-5">
            Core Capabilities
          </p>
          <h2 className="text-5xl font-bold text-[#0A0E27]">
            Military-Grade Protection
          </h2>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-14 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              style={{ boxShadow: '0 8px 32px rgba(10,14,39,0.08)' }}
            >
              <div className="w-16 h-16 flex items-center justify-center mb-8">
                <i className={`${feature.icon} text-6xl text-[#00D4FF]`} style={{ strokeWidth: '2px' }}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A0E27] mb-4">
                {feature.title}
              </h3>
              <p className="text-base text-[#6B7280] leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
